<template>
    <div class="shipping-policy__wrapper">
        <b-form-group label="Shipping policy">
            <hr>
            <template v-if="false">
                <!-- Hide on prod -->
                <label>Policy type *</label>
                <b-form-radio-group
                    id="shipping-policy"
                    v-model="selected"
                    name="shipping-policy"
                    stacked
                >
                    <b-form-radio
                        inline
                        v-for="(option, index) in options"
                        :key="index"
                        :value="option.value"
                        @click.native="checkChanges('type', index, $event)">
                        {{option.text}}
                    </b-form-radio>
                </b-form-radio-group>
            </template>

            <label class="mt-4">If delivery is to Parcel locker:</label>
            <b-form-radio-group
                id="shipping-parcel-locker"
                v-model="selectedLocker"
                name="shipping-parcel-locker"
                stacked
            >
                <b-form-radio
                    inline
                    v-for="(option, index) in optionsLocker"
                    :key="index"
                    :value="option.value"
                    @click.native="checkChanges('locker', index, $event)">
                    {{option.text}}
                </b-form-radio>
            </b-form-radio-group>
        </b-form-group>
        <template v-if="false">
            <!-- Hide on prod -->
            <b-row class=" pt-5">
                <b-col md="12">
                    <AddShippingRule @addShippingRule="ruleId = ''"/>
                    <ShippingRulesList @editShippingRule="editRule"></ShippingRulesList>
                </b-col>
            </b-row>
            <ShippingSettingsModal :ruleId="ruleId" />
        </template>
    </div>
</template>

<script>
    import AddShippingRule from './components/AddRule'
    import ShippingRulesList from './components/RulesList'
    import ShippingSettingsModal from './components/ShippingSettingsModal'
    export default {
        name: 'ShippingPolicySettings',
        data() {
            return {
                selected: 'first',
                options: [
                    { text: 'Deafault Settings', value: 'first' },
                    { text: 'Deafault Settings & Confirmation', value: 'second' },
                    { text: 'Manual Shipping', value: 'third' },
                ],
                ruleId: '',
                selectedLocker: true,
                optionsLocker: [
                    { text: 'Show Parcel lockers list near accordingly delivery services', value: true },
                    { text: 'Don`t show Parcel lockers list near accordingly delivery services', value: false }
                ]
            }
        },
        components: {
            AddShippingRule,
            ShippingRulesList,
            ShippingSettingsModal
        },
        methods: {
            getUserFulfillmentSettings() {
                this.$api('GET', this.$endpoints.settings.fulfillment).then((response) => {
                    this.selectedLocker = response.lockerEnabled
                }).catch((error) => {})
            },
            putUserFulfillmentSettings(val) {
                let body = {
                    'lockerEnabled': val,
                    'autoFulfillmentEnabled': false // just for backend - fake value
                }
                this.$api('PUT', this.$endpoints.settings.fulfillment, body).then((response) => {
                    this.selectedLocker = val
                }).catch((error) => {})
            },
            checkChanges(arr, index, e) {
                e.preventDefault()
                if (e.target.tagName.toLowerCase() === 'label') {
                    this.$bvModal.msgBoxConfirm('Are you sure?', {
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary-user',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: false
                    }).then(value => {
                        if (value) {
                            if (arr === 'type') {
                                this.selected = this.options[index].value
                            }
                            if (arr === 'locker') {
                                this.putUserFulfillmentSettings(this.optionsLocker[index].value)
                            }
                        }
                    }).catch(e => console.log(e))
                }
            },
            editRule(id) {
                this.ruleId = id
            }
        },
        created() {
            this.getUserFulfillmentSettings()
        }
    }
</script>

<style lang="scss">
    .shipping-policy {
        &__wrapper {
            padding-top: 45px;
            padding-bottom: 15px;
            legend.col-form-label {
                font-weight: bold;
                padding-left: 0;
            }
            label.custom-control-label {
                font-weight: normal;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/ShippingPolicySettings/ShippingPolicy.vue